import { render, staticRenderFns } from "./default.vue?vue&type=template&id=7ceb3afc&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Menu: require('/codebuild/output/src1887633789/src/kokalanov/components/global/Menu.vue').default,CookieAgreementPopup: require('/codebuild/output/src1887633789/src/kokalanov/components/global/CookieAgreementPopup.vue').default})
